import {Container, Menu} from 'semantic-ui-react';

import styles from './Footer.module.scss';

const Footer = () => {
  return (
    <Container className={styles.Footer} fluid>
      <Menu fixed="bottom" size="mini" className={styles.Text} borderless>
        <Menu.Item position="right" name="request" link>
          <a
            href="https://cern.service-now.com/service-portal?id=sc_cat_item&name=request&se=web-portal"
            target="_blank"
            rel="noreferrer"
          >
            Submit a request
          </a>
        </Menu.Item>
        <Menu.Item name="incident" link>
          <a
            href="https://cern.service-now.com/service-portal?id=sc_cat_item&name=incident&se=web-portal"
            target="_blank"
            rel="noreferrer"
          >
            Report an incident
          </a>
        </Menu.Item>
      </Menu>
    </Container>
  );
};

export default Footer;
